module.exports = __webpack_public_path__ + "img/img24.cb87d519.png";